<template>
  <v-main class="root-component">
	  <div
		  v-if="$vuetify.breakpoint.xs && !computedAmITeamleader"
		  class="d-flex justify-center align-center pa-5"
		  style="height: 100vh"
	  >
		  Ops! Il Simulatore Click Day è disponibile solo su computer. Per un'esperienza ottimale e per allenarti come un vero professionista, accedi da un PC.<br>
		  Grazie mille e ti aspetto sul desktop!
	  </div>
	  
    <!-- ROOT -->
    <router-view v-else ></router-view>

		<!-- Dialog di conferma -->
    <v-dialog v-model="dialogConferma.isVisibile" max-width="400" persistent>
      <v-card>
        <v-card-title>{{ dialogConferma.titolo }}</v-card-title>
        <v-card-text>{{ dialogConferma.testo }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogConferma.onAnnulla">Annulla</v-btn>
          <v-btn color="green" text @click="dialogConferma.onConferma">Conferma</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import mixin from '../mixins';

import { mapState } from 'vuex';

export default {
	data() {
		return {
		
		}
	},
	computed: {
    ...mapState({ // lo stato della snackbar tra i computed per essere responsiva
      //snackbar: state => state.snackbar, => Per ora non utilizzata a livello globale
      dialogConferma: state => state.dialogConferma
    }),
	}
}
</script>

